import { FelaCSS } from '@bridebook/ui';

interface IStyles {
  sliderWrap: FelaCSS;
  headingWrap: (noPaddingLeft: boolean) => FelaCSS;
}

const style: IStyles = {
  sliderWrap: {
    marginLeft: 0,
    marginRight: 0,
  },
  headingWrap: (noPaddingLeft) => ({
    maxWidthMobile: {
      paddingLeft: noPaddingLeft ? 0 : 4,
    },
  }),
};

export default style;
